import { useAuth0 } from '@auth0/auth0-react';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@sunstone/ui';
import { LogOut } from 'lucide-react';
import { UniphoreLogo } from '@/components/ui/UniphoreLogo';

export function SignedOutPage() {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="flex min-h-[80vh] items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-lg border-border/50">
        <CardHeader className="text-center pb-2">
          <UniphoreLogo className="h-8 mb-6" />
          <div className="mx-auto bg-muted rounded-full w-16 h-16 flex items-center justify-center mb-4">
            <LogOut className="w-8 h-8 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl font-bold">Session Expired</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 text-center">
          <div className="space-y-4 text-muted-foreground">
            <p>
              You have been signed out because your session refresh token is missing or invalid.
            </p>
            <p className="text-sm bg-muted/50 p-3 rounded-md">
              <strong>Note:</strong> You may still see your name in the header because your local
              identity profile is cached, but you need to re-authenticate to access the API.
            </p>
          </div>

          <Button onClick={() => loginWithRedirect()} className="w-full font-semibold" size="lg">
            Sign In Again
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
